import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

export type ReportedGenerationError = {
  indId: string;
  lastUpdatedAt: string;
  section: string;
};
interface LocalStorageStore {
  lastOpenedDocumentSectionNumber: string;
  reportedGenerationErrors: ReportedGenerationError[];
  setReportedGenerationErrors: (
    reportedGenerationErrors: ReportedGenerationError[],
  ) => void;
  setLastOpenedDocumentSectionNumber: (
    lastOpenedDocumentSectionNumber: string,
  ) => void;
}

const useLocalStorageStore = create<LocalStorageStore>()(
  devtools(
    persist(
      (set, get) => ({
        lastOpenedDocumentSectionNumber: '',
        setLastOpenedDocumentSectionNumber: (
          lastOpenedDocumentSectionNumber,
        ) => {
          if (
            get().lastOpenedDocumentSectionNumber ===
            lastOpenedDocumentSectionNumber
          ) {
            return;
          }

          return set({
            lastOpenedDocumentSectionNumber: lastOpenedDocumentSectionNumber,
          });
        },
        reportedGenerationErrors: [],
        setReportedGenerationErrors: (reportedGenerationErrors) => {
          return set({ reportedGenerationErrors });
        },
      }),
      {
        name: 'last-openned-document-section-number',
      },
    ),
  ),
);

export const useLastOpenedDocumentSectionNumber = () =>
  useLocalStorageStore((state) => state.lastOpenedDocumentSectionNumber);
export const useReportedGenerationErrors = () =>
  useLocalStorageStore((state) => state.reportedGenerationErrors);

export const useLocalStorageStoreActions = () =>
  useLocalStorageStore((state) => ({
    setLastOpenedDocumentSectionNumber:
      state.setLastOpenedDocumentSectionNumber,
    setReportedGenerationErrors: state.setReportedGenerationErrors,
  }));
